import { createContext, useContext, useState } from "react";

const authContext = createContext({
  accessToken: '',
  adminRole: '',
  user: {
    id: 0,
    avatar: '',
    firstName: '',
    lastName: '',
    email: '',
    tel: '',
    point: 0,
  },
  termAccept: false,
  loadUser: async () => { },
  login: async () => { },
  acceptTerm: () => { },
  logout: () => { },
  getHome: () => { },
});

function useProvideAuth() {
  const storage = {
    accessToken: localStorage.getItem('accessToken'),
    adminRole: localStorage.getItem('adminRole'),
    user: localStorage.getItem('user'),
    termAccept: localStorage.getItem('termAccept'),
  };

  const [accessToken, setAccessToken] = useState(storage.accessToken);
  const [adminRole, setAdminRole] = useState(storage.adminRole);
  const [user, setUser] = useState(storage.user && JSON.parse(storage.user));
  const [termAccept, setTermAccept] = useState(storage.termAccept === 'true');

  async function loadUser(accessToken) {
    const url = new URL('/api/user/self', window.location);
    const res = await fetch(url, {
      headers: { 'X-ACCESS-TOKEN': accessToken },
    });
    if (res.ok) {
      const data = await res.json();
      setUser(data.user);
      localStorage.setItem('user', JSON.stringify(data.user));
    }
  }

  async function login(accessToken, adminRole, save) {
    await loadUser(accessToken);

    setAdminRole(adminRole);
    setAccessToken(accessToken);

    if (save) {
      localStorage.setItem('adminRole', adminRole);
      localStorage.setItem('accessToken', accessToken);
    }
  }

  function acceptTerm() {
    setTermAccept(true);
    localStorage.setItem('termAccept', 'true');
  }

  function logout() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('adminRole');
    localStorage.removeItem('user');
    setAccessToken(null);
    setAdminRole(null);
    setUser(null);
  }

  function getHome() {
    switch (adminRole) {
      case 'admin':
        return "/user-detail";

      case 'merchant':
        return "/user-detail";

      case 'landlord':
        return "/user-detail";

      default:
        return "/user-detail";
    }
  }

  return {
    accessToken,
    adminRole,
    user,
    termAccept,
    loadUser,
    login,
    acceptTerm,
    logout,
    getHome,
  };
}

export function useAuth() {
  return useContext(authContext);
}

export function AuthProvider({ children }) {
  const auth = useProvideAuth();
  const { Provider } = authContext;
  return (
    <Provider value={auth}>
      {children}
    </Provider>
  );
}
